import { render, staticRenderFns } from "./CheckoutDialog.vue?vue&type=template&id=3dd74a86&scoped=true"
import script from "./CheckoutDialog.vue?vue&type=script&lang=js"
export * from "./CheckoutDialog.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDialog.vue?vue&type=style&index=0&id=3dd74a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd74a86",
  null
  
)

export default component.exports